import { createBrowserHistory } from 'history';
import config from '../helpers/config';

const history = createBrowserHistory({ basename: config.APP_URL });

export default history;
